import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Handles the URL fragment returned by Emergent Google OAuth:
 *   /dashboard#session_id=...
 * Exchanges it for a session_token cookie via POST /api/auth/session, then
 * lands the user on /dashboard.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      // Clean the URL immediately so the fragment isn't re-processed on reload
      window.history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
      );
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        await api.post("/auth/session", { session_id: sessionId });
        await refreshUser();
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [navigate, refreshUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-slate-50"
      data-testid="auth-callback"
    >
      <div className="text-slate-500 text-sm">Signing you in…</div>
    </div>
  );
}
